export class FilterStore {
    constructor(
        public userId: number,
        public filter: number) {
    }
}